import Component from '@glimmer/component'
import { service } from '@ember/service'
import type SideNavService from 'teacher-ui-client/services/side-nav'
import { SideNavAccordionItem, SideNavAccordionList } from 'teacher-ui-client/components/side-nav/accordion'
import graphUnfilled from '@images/icons/graph-unfilled.svg'
import { posthogEvent } from 'teacher-ui-client/modifiers/posthog'
import { t } from 'ember-intl'

export class WritingLegendsReportsAccordion extends Component {
  @service sideNav!: SideNavService

  get uiScopeModels() {
    return this.sideNav.uiScopeModels ?? []
  }

  <template>
    <SideNavAccordionList @iconUrl={{graphUnfilled}} @iconAlt="Sidenav bar" @label={{t "sideNav.reports.title"}}>
      <SideNavAccordionItem
        @route="reporting.ui-scope.writing-legends.dashboard-table"
        @models={{this.sideNav.uiScopeModels}}
        {{posthogEvent "Reporting" product="writing-legends" page="dashboard-table"}}
      >
        {{t "sideNav.reports.dashboard"}}
      </SideNavAccordionItem>
      <SideNavAccordionItem
        @route="reporting.ui-scope.writing-legends.time-on-task"
        @models={{this.sideNav.uiScopeModels}}
        {{posthogEvent "Reporting" product="writing-legends" page="time-on-task"}}
      >
        {{t "sideNav.reports.timeOnTask"}}
      </SideNavAccordionItem>
      <SideNavAccordionItem
        @route="reporting.ui-scope.writing-legends.course-progress"
        @models={{this.sideNav.uiScopeModels}}
        {{posthogEvent "Reporting" product="writing-legends" page="course-progress"}}
      >
        {{t "sideNav.reports.courseProgress"}}
      </SideNavAccordionItem>
      <SideNavAccordionItem
        @route="reporting.ui-scope.writing-legends.quizzes-completed"
        @models={{this.sideNav.uiScopeModels}}
        {{posthogEvent "Reporting" product="writing-legends" page="quizzes-completed"}}
      >
        {{t "sideNav.reports.quizzesCompleted"}}
      </SideNavAccordionItem>
      <SideNavAccordionItem
        @route="reporting.ui-scope.writing-legends.spelling"
        @models={{this.sideNav.uiScopeModels}}
        {{posthogEvent "Reporting" product="writing-legends" page="spelling"}}
      >
        {{t "sideNav.reports.spelling"}}
      </SideNavAccordionItem>
      <SideNavAccordionItem
        @route="reporting.ui-scope.writing-legends.vocabulary.bank.new-words"
        @currentWhen="reporting.ui-scope.writing-legends.vocabulary"
        @models={{this.sideNav.uiScopeModels}}
        {{posthogEvent "Reporting" product="writing-legends" page="vocabulary"}}
      >
        {{t "sideNav.reports.vocabulary"}}
      </SideNavAccordionItem>
    </SideNavAccordionList>
  </template>
}

export default WritingLegendsReportsAccordion
